import { useEffect, useState } from "react";
import Header from "../../component/items/Header";
import Input from "../../component/items/Input";
import Button from "../../component/items/Button";
import { dataPost, dataGet } from "../../network";
import { Dialog } from "../../component/items/Dialog";
import { dialogDataTypes } from "../../component/items/itemDataType";
import { signupUrl, countryAutoComplete } from "../../network/const";
import { Link, useNavigate } from "react-router-dom";
import SearchableSelect from "../../component/items/SearchableSelect";

const fields = [
  { id: "fullName", labelText: "Full Name", type: "text", isRequired: true },
  { id: "email", labelText: "Email address", type: "email", isRequired: true },
  { id: "password", labelText: "Password", type: "password", isRequired: true },
  {
    id: "confirmPassword",
    labelText: "Confirm Password",
    type: "password",
    isRequired: true,
  },
  { id: "jobTitle", labelText: "Job Title", type: "text", isRequired: true },
  {
    id: "companyName",
    labelText: "Company Name",
    type: "text",
    isRequired: true,
  },
];

function Signup() {
  const navigate = useNavigate();

  const [countries, setCountries] = useState<
    { countryId: number; countryName: string }[]
  >([]);

  const [formState, setFormState] = useState<any>({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    jobTitle: "",
    companyName: "",
    country: "",
    countryId: "",
  });

  const [dialog, setDialog] = useState(false);
  const [dialogData, setDialogData] = useState<dialogDataTypes>({
    title: "",
    description: "",
    btnText: "",
    status: false,
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const fetchCountries = async () => {
    const res = await dataGet(countryAutoComplete, {});
    if (res.status) {
      setCountries(res.data);
    }
  };
    //State for the Agreed
    const [isAgreed, setIsAgreed] = useState(false); 

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
    console.log(formState);
  };

  const dialogInit = ({
    title,
    btnText,
    description,
    status,
  }: dialogDataTypes) => {
    setDialogData({ title, btnText, description, status });
  };

  const validate = () => {
    let isValid = true;
    const newErrors: any = {};

    if (!formState.fullName) {
      newErrors.fullName = "Full name is required.";
      isValid = false;
    }

    if (!formState.email || !/\S+@\S+\.\S+/.test(formState.email)) {
      newErrors.email = "Valid email is required.";
      isValid = false;
    }

    if (!formState.password || formState.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
      isValid = false;
    }

    if (formState.confirmPassword !== formState.password) {
      newErrors.confirmPassword = "Passwords do not match.";
      isValid = false;
    }

    if (!formState.jobTitle) {
      newErrors.jobTitle = "Job title is required.";
      isValid = false;
    }

    if (!formState.companyName) {
      newErrors.companyName = "Company name is required.";
      isValid = false;
    }

    if (!formState.countryId) {
      newErrors.country = "Please select a country.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e: any) => {
    console.log(formState);
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await dataPost(signupUrl, formState, { silent: false });

      setDialog(true);
      dialogInit({
        title: response.status
          ? "Registration Successful"
          : response.title || "Signup Failed",
        description: response.message || "Something went wrong.",
        btnText: "OK",
        status: response.status,
      });
    } catch (error: any) {
      // Optional: handle network/server errors
      setDialog(true);
      dialogInit({
        title: "Error",
        description:
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong.",
        btnText: "OK",
        status: false,
      });
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="max-w-md w-full space-y-8">
        <Header
          heading="Create a new account"
          paragraph="Already have an account?"
          linkName="Login"
          linkUrl="/login"
        />
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-5">
            {fields.map((field) => (
              <div key={field.id}>
                <Input
                  handleChange={handleChange}
                  value={formState[field.id] || ""}
                  labelText={field.labelText}
                  labelFor={field.id}
                  id={field.id}
                  name={field.id}
                  type={field.type}
                  isRequired={field.isRequired}
                  placeholder={field.labelText}
                  customClass={""}
                />
                {errors[field.id] && (
                  <span className="text-red-600 text-sm mt-0 block">
                    * {errors[field.id]}
                  </span>
                )}
              </div>
            ))}
            {/* <Select
              id="country"
              name="country"
              labelText="Country"
              isRequired={true}
              value={formState.countryName}
              placeholder="Country"
              options={countries.map((c) => ({
                label: c.countryName,
                value: c.countryId.toString(),
              }))}
              handleChange={(value: string) => {
                const selected = countries.find(
                  (c) => c.countryId.toString() === value
                );
                setFormState({
                  ...formState,
                  country: selected?.countryName || "",
                  countryId: selected?.countryId.toString() || "",
                });
              }}
            />
            {errors.country && (
              <p className="text-red-600 text-sm mt-px">* {errors.country}</p>
            )} */}

            <SearchableSelect
              id="country"
              labelText="Country"
              isRequired={true}
              value={formState.countryId}
              placeholder="Select Country"
              options={countries.map((c) => ({
                label: c.countryName,
                value: c.countryId.toString(),
              }))}
              handleChange={(value: string) => {
                const selected = countries.find(
                  (c) => c.countryId.toString() === value
                );
                setFormState({
                  ...formState,
                  country: selected?.countryName || "",
                  countryId: selected?.countryId.toString() || "",
                });
              }}
            />
            {errors.country && (
              <p className="text-red-600 text-sm mt-px">* {errors.country}</p>
            )}

             {/* Terms and Conditions */}
             <div className="flex items-center space-x-2 mt-4">
              <input
                type="checkbox"
                id="terms"
                checked={isAgreed}
                onChange={() => setIsAgreed(!isAgreed)}
                className="h-4 w-4 border-gray-300 rounded"
              />
              <label htmlFor="terms" className="text-sm text-gray-700">
                I agree to the{" "}
                <Link
                  to="/terms-and-conditions"
                  className="text-blue-600 underline"
                >
                  Terms and Conditions
                </Link>
              </label>
            </div>


            <div className="mt-8">
              <Button
                action="submit"
                handleSubmit={handleSubmit}
                text="Sign Up"
                disabled={!isAgreed}
                customClass={!isAgreed ? "opacity-50" : ""}
              />
            </div>
          </div>
        </form>

        <Dialog
          open={dialog}
          handleOpen={() => {
            setDialog(false);
            if (dialogData.status) {
              console.log(dialogData.status, "dialogData.status");
              navigate("/login");
            }
          }}
          description={dialogData.description}
          title={dialogData.title}
          buttonText={dialogData.btnText}
        />
      </div>
    </div>
  );
}

export default Signup;
